import React from 'react';
import { Typography, Image, Row, Col, Divider, Collapse } from 'antd';
import { styles } from '../../../styles';
import { Link } from 'react-router-dom';
import { useMediaQuery } from '../../../hooks/MediaQuery.hook';
import RelatedBlog from './RelatedBlogs';
import { blogs } from '../../../utils/constant';
import Panel from '../../../components/common/Panel';
import BlogFooter from '../../../components/BlogFooter';

const { Title, Paragraph } = Typography;

export default function Blog9() {

  const matches = useMediaQuery('(min-width: 768px)');

  return (
    <>
    <Row style={styles.navLinks}>        
       <p><Link to={'/'}>Home</Link> / <Link to={'/blogs'}>Blogs </Link>/ {blogs[8].title}<span></span></p>
    </Row>
    <Row justify="center">
      <Col xs={24} sm={22} md={20} lg={16}>

        <div style={styles.blogContainer}>
          <Typography>
            <Title level={1} style={{...styles.mainHeading, fontSize: !matches ? '28px': ''}}>
            {blogs[8].title}
            </Title>
            <Paragraph style={styles.blogParagraph}>
            Football, often referred to as, the beautiful game, has captivated millions around the world. However, the spirit of sportsmanship has been increasingly overshadowed by violent clashes among fans. The alarming rise in football-related hooliganism has raised concerns among governing bodies, law enforcement, and true lovers of the sport. A recent brawl between rival supporters has reignited discussions about the measures needed to curb this disturbing trend.
            </Paragraph>

            <Image
              preview={false}
              src={blogs[8].image}
              alt={blogs[8].title}
              style={{ borderRadius: '8px', width: '95%', margin: '10px' }}
            />

            <Title level={2} style={{...styles.mainHeading, fontSize: !matches ? '24px': ''}}>
            The Incident: A Night of Chaos
            </Title>

            <Paragraph style={styles.blogParagraph}>
            During a highly anticipated league match between two rival clubs, what began as passionate chanting soon escalated into an all-out riot? Tempers flared as tensions between the fans boiled over, leading to verbal abuse, physical confrontations, and the destruction of stadium property. 
            </Paragraph>
            <Paragraph style={styles.blogParagraph}>
            Security forces found themselves overwhelmed as fights erupted both inside and outside the stadium. Multiple fans suffered injuries, and law enforcement had to intervene with tear gas and arrests to restore order.
            </Paragraph>

            <Title level={2} style={{...styles.mainHeading, fontSize: !matches ? '24px': ''}}>
            The Growing Trend of Football Hooliganism
            </Title>

            <Paragraph style={styles.blogParagraph}>
            Football hooliganism is not a new phenomenon, but its increasing frequency and intensity have sparked major concerns. This aggressive fan behavior often stems from deep-seated rivalries, excessive alcohol consumption, and a lack of adequate security measures. 
            </Paragraph>

            <Title level={2} style={{...styles.mainHeading, fontSize: !matches ? '24px': ''}}>
            Root Causes of Fan Violence
            </Title>

            <Paragraph style={styles.blogParagraph}>
                Several factors contribute to the growing trend of fan violence in football:
                <ul>
                <li>Club Rivalries – Historic rivalries often bring out the worst in fans, leading to premeditated violence.</li>
                <li>Alcohol and Drug Influence – Substance abuse impairs judgment and fuels aggression.</li>
                <li>Social Media Influence – Online fan clashes escalate real-life conflicts.</li>
                <li>Lack of Proper Security – Insufficient security measures allow violence to spiral out of control.</li>
                <li>Peer Pressure – Young fans sometimes engage in violence to gain acceptance within hooligan groups.</li>
                <li>Political and Social Factors – In some cases, fan groups have links to political movements, adding another layer of hostility to rivalries.</li>
                </ul>
            </Paragraph>
            
            <Divider />
            <Title level={2} style={{...styles.blogHeading, textAlign: 'start' }}>
            Impact on the Sport            
            </Title>

            <Paragraph style={styles.blogParagraph}>
            The impact of fan violence extends beyond the immediate harm caused during riots. Football clubs suffer financial penalties, stadium bans, and loss of reputation. 
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            Moreover, innocent fans, including families and children, often fall victim to these incidents, leading to declining stadium attendance. Sponsors and broadcasters also hesitate to associate their brands with clubs known for hooliganism, which affects the overall growth of the sport. The economic impact can be severe, as clubs and leagues lose revenue from ticket sales, merchandising, and advertising.
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            The violent behavior of fans also influences young supporters, setting a dangerous precedent for future generations. Instead of fostering a love for the sport, younger fans may grow up believing that aggression and intimidation are integral to supporting their teams.
            </Paragraph>

            <Divider />
            <Title level={2} style={{...styles.blogHeading, textAlign: 'start' }}>
            Psychological Aspects of Fan Violence           
            </Title>

            <Paragraph style={styles.blogParagraph}>
            Psychologists argue that mob mentality plays a significant role in football violence. When individuals join large crowds, they tend to act in ways they normally wouldn’t when alone. 
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            The anonymity provided by a massive group emboldens fans to engage in violent behavior without fearing immediate consequences. This herd mentality, coupled with the adrenaline rush of a competitive atmosphere, fuels aggression.
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            In some cases, football violence also serves as an outlet for social frustration. Economic hardships, political unrest, and social inequalities can contribute to heightened aggression among fans, who channel their frustrations into their football rivalries. As a result, hooliganism becomes more than just a sporting issue; it is intertwined with broader societal problems.
            </Paragraph>

            <Divider />
            <Title level={2} style={{...styles.blogHeading, textAlign: 'start' }}>
            Steps to Prevent Football Violence           
            </Title>

            <Paragraph style={styles.blogParagraph}>
            <ul>
                <li>To tackle football violence effectively, governing bodies, law enforcement, and clubs must take proactive measures:</li>

                <li>Stronger Security Protocols – Increasing police presence and surveillance at stadiums.</li>
                <li>Stricter Penalties – Enforcing lifetime bans on repeat offenders.</li>
                <li>Educating Fans – Promoting anti-violence campaigns within clubs and communities.</li>
                <li>Regulating Alcohol Sales – Limiting alcohol consumption during matches.</li>
                <li>Better Crowd Control – Implementing stricter entry and exit procedures.</li>
                <li>Technology and AI Monitoring – Using facial recognition and AI surveillance to track and prevent violence before it escalates.</li>
                <li>Community Engagement Programs – Encouraging dialogue between rival fan groups to foster mutual respect.</li>
            </ul>
            </Paragraph>

            <Divider />
            <Title level={2} style={{...styles.blogHeading, textAlign: 'start' }}>
            Real-Life Examples of Successful Interventions:          
            </Title>

            <Paragraph style={styles.blogParagraph}>
                <ul>
                    <li>UK – Introduced strict legal penalties and banned troublemakers from stadiums in the 1980s to combat hooliganism.</li>
                    <li>Germany – Engaged fan groups in dialogue to promote peaceful rivalries and prevent violence.</li>
                    <li>Argentina – Implemented biometric registration systems to bar violent fans from stadiums.</li>
                    <li>Italy – Introduced fan passports to restrict entry to high-risk individuals.</li>
                </ul>
            </Paragraph>

            <Title level={2} style={{...styles.blogHeading, textAlign: 'start' }}>
            Conclusion          
            </Title>

            <Paragraph style={styles.blogParagraph}>
            Football should remain a game that unites people, not divides them through violence. While passion and enthusiasm are essential to the sport, they should never cross the line into aggression and chaos. 
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            Authorities, clubs, and fans must work together to eliminate hooliganism and restore the sport’s true spirit. The future of football depends on fostering an environment where every supporter, regardless of their club allegiance, can enjoy matches without fear.
            </Paragraph>

            <div style={{  margin: '0 auto', padding: '10px' }}>
                <Title level={3} style={{ textAlign: 'center', marginBottom: '20px', color: '#fff' }}>
                    Frequently Asked Questions (FAQs)
                </Title>
                <Collapse accordion style={{color: '#fff'}}>
                    <Panel header={'1. Why do football fans fight?'} key="1" style={{background: '#fff'}}>
                    <p>
                        Football fans engage in fights due to intense rivalries, alcohol
                        consumption, and social pressures within supporter groups. In some
                        cases, political and social issues also contribute to heightened
                        tensions.
                    </p>
                    </Panel>
                    <Panel header="2. How can stadium security be improved?" key="2" style={{background: '#fff'}}>
                    <p>
                        Stadium security can be improved through increased police presence,
                        advanced surveillance systems, AI-based monitoring, and stricter
                        entry protocols.
                    </p>
                    </Panel>
                    <Panel header="3. What are the legal consequences of football violence?" key="3" style={{background: '#fff'}}>
                    <p>
                        Fans involved in violence may face fines, stadium bans, and even
                        imprisonment in severe cases. In some countries, biometric tracking
                        prevents repeat offenders from attending matches.
                    </p>
                    </Panel>
                    <Panel header="4. How can clubs prevent fan violence?" key="4" style={{background: '#fff'}}>
                    <p>
                        Clubs can prevent fan violence by promoting anti-hooliganism
                        campaigns, engaging with fan groups, working closely with law
                        enforcement, and implementing stricter ticketing policies to screen
                        attendees.
                    </p>
                    </Panel>
                    <Panel header="5. Has football violence decreased over time?" key="5" style={{background: '#fff'}}>
                    <p>
                        In some countries, such as the UK and Germany, football violence has
                        decreased due to strict regulations. However, it remains a serious
                        issue in other parts of the world, particularly in regions where
                        enforcement is weak.
                    </p>
                    </Panel>
                    <Panel header="6. Does social media play a role in fan violence?" key="6" style={{background: '#fff'}}>
                    <p>
                        Yes, social media platforms can escalate tensions between rival
                        fans, spreading hate speech and organizing violent encounters.
                        Monitoring and regulating such interactions can help mitigate
                        conflicts.
                    </p>
                    </Panel>
                </Collapse>
            </div>

            <Divider/>
            <Title level={4} style={{...styles.blogHeading, textAlign: 'start', fontSize: '18px' }}>
            Read More Here
            </Title>
            <div style={{ paddingRight: '10px' }}>
              <RelatedBlog excludedId={9} />
            </div>

            <BlogFooter />
          </Typography>
        </div>
      </Col>
    </Row>
    </>
  );
}
